import { OrmState } from 'redux-orm';
import Store from '..';

export namespace ActivitySelectors {
	export const getConversation = (
		state: { entities: OrmState<any> },
		id: string
	) => Store.ORM.session(state.entities).ConversationThread.withId(id);
}
